// Geteilte Bounds-Logik fuer Canvas-Objekte. LinkLayer (Anchor-Berechnung) und
// Canvas (Edge-Drag-Connector Port-Position) brauchen identische Werte.
// Optional-Size-Typen (sticky/text/req/pain/dep) fallen auf OBJECT_META.defaultSize
// zurueck wenn width/height nicht gesetzt sind.

import { type CanvasObject, OBJECT_META } from "@ms-whiteboard/shared";

export interface Bounds {
  w: number;
  h: number;
}

export function objectBounds(obj: CanvasObject): Bounds {
  const meta = OBJECT_META[obj.type];
  if (meta.hasExplicitSize) {
    const sized = obj as CanvasObject & { width: number; height: number };
    return { w: sized.width, h: sized.height };
  }
  const optional = obj as CanvasObject & { width?: number; height?: number };
  const w = typeof optional.width === "number" ? optional.width : meta.defaultSize.width;
  const h = typeof optional.height === "number" ? optional.height : meta.defaultSize.height;
  return { w, h };
}

export type PortEdge = "n" | "e" | "s" | "w";

export function portWorldPoint(obj: CanvasObject, edge: PortEdge): { x: number; y: number } {
  const b = objectBounds(obj);
  const cx = obj.x + b.w / 2;
  const cy = obj.y + b.h / 2;
  switch (edge) {
    case "n":
      return { x: cx, y: obj.y };
    case "e":
      return { x: obj.x + b.w, y: cy };
    case "s":
      return { x: cx, y: obj.y + b.h };
    case "w":
      return { x: obj.x, y: cy };
  }
}
